import { PlessResponderSub } from '../../../../commons/kymw00/pless-responder-sub.service';
import { KYMW0A00Model } from '../kymw0a00.model';
import { MembersVoiceInputDataModel } from '../vo/members-voice-input-data.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW00Model } from '../../../kymw00/kymw00.model';

/**
 * 組合員の声データ取込みをするサービス
 *
 * @export UpdateMembersVoiceDataService
 * @class UpdateMembersVoiceDataService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateMembersVoiceDataService extends PlessJsonResponderSub<any> {
  private model: KYMW0A00Model = null;
  private vo: MembersVoiceInputDataModel;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateMembersVoiceDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ReceiptNum: this.vo.receiptNum,
        CorrectMemberName: this.kymw00Model.deleteStartAndEndSpace(this.vo.correctMemberName),
        CorrectAnonymous: this.kymw00Model.deleteStartAndEndSpace(this.vo.correctAnonymous),
        CenterCoopDiv: this.vo.centerCoopDiv,
        CenterName: this.kymw00Model.deleteStartAndEndSpace(this.vo.centerName),
        CorrectInquiryContents: this.kymw00Model.deleteStartAndEndSpace(this.vo.correctInquiryContents)
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model KYMW0A00Model
   * @memberof UpdateMembersVoiceDataService
   */
  execute(model: KYMW0A00Model, vo: MembersVoiceInputDataModel, successFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('updateMembersVoiceData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateMembersVoiceDataService
   */
  success(data: any): void {
    this.successFunc();
  }
}
